// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard.css */

.dashboard-container {
  background-color: #ffffff;
  height: 90vh;
  font-size: 13px;
}

.dashboard {
  padding: 20px;
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 80vh;
  max-width: none;
}

.filters-container {
  background-color: whitesmoke;
  padding: 5px;
  border-radius: 10px;
  font-weight: bold;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
}

.cards-container {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  flex-wrap: wrap;
}

.dashboard-card {
  background-color: #E0F7FF;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  flex: 1 1 30%; /* Adjust the base size and allow to grow */
  margin: 10px;
  text-align: center;
  font-weight: bold;
}

.feedback-content {
  flex: 1 1;
  overflow-y: auto;
  margin-top: 20px;
}

.feedback-item {
  padding: 10px;
  border-bottom: 1px solid #ddd;
}

.feedback-chart-row-1 {
  margin-bottom: 20px;
  display: flex;
  padding: 5px;
  margin-top: 10px;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
}

.chart-container {
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1),
              -1px -1px 2px rgba(0, 0, 0, 0.1),
              1px -1px 2px rgba(0, 0, 0, 0.1),
              -1px 1px 2px rgba(0, 0, 0, 0.1);
  flex: 1 1 45%; /* Adjust the base size and allow to grow */
  min-width: 250px; /* Ensure charts don't shrink too much */
}

.small-chart {
  flex-basis: 25%; /* Base width for small chart */
  flex-grow: 1; /* Allow small chart to grow */
}

.large-chart {
  flex-basis: 30%; /* Base width for large charts */
  flex-grow: 2; /* Allow large charts to grow more */
}

.large-chart-1 {
  flex-basis: 66%; /* Base width for large charts */
  flex-grow: 2; /* Allow large charts to grow more */
}

.chart-heading {
  text-align: center;
  font-weight: bold;
  color: #496c58;
  margin-bottom: 0;
}

.dashboard-date-filter {
  text-align: right;
  cursor: pointer;
  border-style: solid;
  /* width: 300px; */
  display: flex;
  align-self: flex-end;
  margin-bottom: 10px;
  border-width: 0.09mm;
  border-color: lightgray;
  border-radius: 5px;
  /* font-weight: bold; */
  padding: 6px;
  background-color: white;
  color: grey;
  min-height: 38px;
}

.custom-date-picker {
  position: absolute;
  z-index: 1000;
  background-color: white;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  padding: 10px;
  border-radius: 5px;
  right: 3%;
  top: 20%;
}

.clear-date-filter-button {
  margin-left: 10px;
  background-color: transparent;
  border: none;
  color: red;
  cursor: pointer;
  font-size: 13px;
}

.clear-all-filters {
  cursor: pointer;
  font-size: inherit;
  margin-bottom: 10px;
  padding: 0;
  border-color: grey;
  font-weight: bold;
  padding: 5px;
}

.clear-all-filters:disabled:hover,
.clear-all-filters:disabled:focus {
  background-color: transparent !important;
  border-color: gray !important;
  color: gray !important;
}

.clear-all-filters:hover,
.clear-all-filters:focus {
  background-color: transparent;
  border-color: gray;
  color: gray;
}

@media (max-width: 768px) {
  
  .dashboard {
    padding: 15px;
    width: 85vw;
  }

  .feedback-item {
    padding: 8px;
  }

  .cards-container {
    flex-direction: column;
    flex-wrap: nowrap; /* Ensure items don't wrap */
  }

  .dashboard-card {
    margin: 10px 0;
    flex: 1 1 100%; /* Full width for small screens */
  }

  .feedback-chart-row-1 {
    flex-direction: column;
    gap: 15px; /* Adjust gap for better fit on small screens */
    flex-wrap: nowrap; /* Ensure items don't wrap */
  }

  .filters-container {
    padding: 10px; /* Adjust padding for smaller screens */
    background-color: white;
    box-shadow: none;
  }

  .filters-container .row {
    flex-direction: column; /* Stack columns vertically */
  }

  .filters-container .col {
    width: 100%; /* Full width for each column */
    margin-bottom: 10px; /* Space between stacked columns */
  }

  .filters-container .dashboard-date-filter {
    width: 100%; /* Full width for date filter */
    text-align: left; /* Align text to the left */
  }

}

@media (max-width: 480px) {
  .dashboard-card {
    flex: 1 1 100%;
  }

  .chart-container {
    flex: 1 1 100%;
  }

  .dashboard {
    padding: 10px; /* Reduce padding for very small screens */
  }

  .feedback-item {
    padding: 8px; /* Adjust padding for smaller screens */
  }

  .dashboard-card {
    font-size: 12px; /* Smaller font size for very small screens */
  }

  .chart-heading {
    font-size: 14px; /* Smaller font size for very small screens */
  }

  .dashboard-date-filter {
    font-size: 12px; /* Adjust font size for small screens */
    padding: 4px; /* Reduce padding for smaller screens */
  }

  .filters-container {
    padding: 10px; /* Adjust padding for smaller screens */
    background-color: white;
    box-shadow: none;
  }

  .filters-container .row {
    flex-direction: column; /* Stack columns vertically */
  }

  .filters-container .col {
    width: 100%; /* Full width for each column */
    margin-bottom: 10px; /* Space between stacked columns */
  }

  .filters-container .dashboard-date-filter {
    width: 100%; /* Full width for date filter */
    text-align: left; /* Align text to the left */
  }

}
`, "",{"version":3,"sources":["webpack://./src/Components/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa,EAAE,2CAA2C;EAC1D,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,WAAW;AACb;;AAEA;EACE;;;6CAG2C;EAC3C,aAAa,EAAE,2CAA2C;EAC1D,gBAAgB,EAAE,wCAAwC;AAC5D;;AAEA;EACE,eAAe,EAAE,+BAA+B;EAChD,YAAY,EAAE,8BAA8B;AAC9C;;AAEA;EACE,eAAe,EAAE,gCAAgC;EACjD,YAAY,EAAE,oCAAoC;AACpD;;AAEA;EACE,eAAe,EAAE,gCAAgC;EACjD,YAAY,EAAE,oCAAoC;AACpD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,2CAA2C;EAC3C,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;;EAEE,wCAAwC;EACxC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;EAEE,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,iBAAiB,EAAE,4BAA4B;EACjD;;EAEA;IACE,cAAc;IACd,cAAc,EAAE,iCAAiC;EACnD;;EAEA;IACE,sBAAsB;IACtB,SAAS,EAAE,+CAA+C;IAC1D,iBAAiB,EAAE,4BAA4B;EACjD;;EAEA;IACE,aAAa,EAAE,uCAAuC;IACtD,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB,EAAE,6BAA6B;EACvD;;EAEA;IACE,WAAW,EAAE,+BAA+B;IAC5C,mBAAmB,EAAE,kCAAkC;EACzD;;EAEA;IACE,WAAW,EAAE,+BAA+B;IAC5C,gBAAgB,EAAE,2BAA2B;EAC/C;;AAEF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa,EAAE,0CAA0C;EAC3D;;EAEA;IACE,YAAY,EAAE,uCAAuC;EACvD;;EAEA;IACE,eAAe,EAAE,6CAA6C;EAChE;;EAEA;IACE,eAAe,EAAE,6CAA6C;EAChE;;EAEA;IACE,eAAe,EAAE,uCAAuC;IACxD,YAAY,EAAE,uCAAuC;EACvD;;EAEA;IACE,aAAa,EAAE,uCAAuC;IACtD,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB,EAAE,6BAA6B;EACvD;;EAEA;IACE,WAAW,EAAE,+BAA+B;IAC5C,mBAAmB,EAAE,kCAAkC;EACzD;;EAEA;IACE,WAAW,EAAE,+BAA+B;IAC5C,gBAAgB,EAAE,2BAA2B;EAC/C;;AAEF","sourcesContent":["/* Dashboard.css */\r\n\r\n.dashboard-container {\r\n  background-color: #ffffff;\r\n  height: 90vh;\r\n  font-size: 13px;\r\n}\r\n\r\n.dashboard {\r\n  padding: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: auto;\r\n  height: 80vh;\r\n  max-width: none;\r\n}\r\n\r\n.filters-container {\r\n  background-color: whitesmoke;\r\n  padding: 5px;\r\n  border-radius: 10px;\r\n  font-weight: bold;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.cards-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-top: 20px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.dashboard-card {\r\n  background-color: #E0F7FF;\r\n  border-radius: 10px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  flex: 1 1 30%; /* Adjust the base size and allow to grow */\r\n  margin: 10px;\r\n  text-align: center;\r\n  font-weight: bold;\r\n}\r\n\r\n.feedback-content {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  margin-top: 20px;\r\n}\r\n\r\n.feedback-item {\r\n  padding: 10px;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.feedback-chart-row-1 {\r\n  margin-bottom: 20px;\r\n  display: flex;\r\n  padding: 5px;\r\n  margin-top: 10px;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n  gap: 20px;\r\n  width: 100%;\r\n}\r\n\r\n.chart-container {\r\n  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1),\r\n              -1px -1px 2px rgba(0, 0, 0, 0.1),\r\n              1px -1px 2px rgba(0, 0, 0, 0.1),\r\n              -1px 1px 2px rgba(0, 0, 0, 0.1);\r\n  flex: 1 1 45%; /* Adjust the base size and allow to grow */\r\n  min-width: 250px; /* Ensure charts don't shrink too much */\r\n}\r\n\r\n.small-chart {\r\n  flex-basis: 25%; /* Base width for small chart */\r\n  flex-grow: 1; /* Allow small chart to grow */\r\n}\r\n\r\n.large-chart {\r\n  flex-basis: 30%; /* Base width for large charts */\r\n  flex-grow: 2; /* Allow large charts to grow more */\r\n}\r\n\r\n.large-chart-1 {\r\n  flex-basis: 66%; /* Base width for large charts */\r\n  flex-grow: 2; /* Allow large charts to grow more */\r\n}\r\n\r\n.chart-heading {\r\n  text-align: center;\r\n  font-weight: bold;\r\n  color: #496c58;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.dashboard-date-filter {\r\n  text-align: right;\r\n  cursor: pointer;\r\n  border-style: solid;\r\n  /* width: 300px; */\r\n  display: flex;\r\n  align-self: flex-end;\r\n  margin-bottom: 10px;\r\n  border-width: 0.09mm;\r\n  border-color: lightgray;\r\n  border-radius: 5px;\r\n  /* font-weight: bold; */\r\n  padding: 6px;\r\n  background-color: white;\r\n  color: grey;\r\n  min-height: 38px;\r\n}\r\n\r\n.custom-date-picker {\r\n  position: absolute;\r\n  z-index: 1000;\r\n  background-color: white;\r\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n  right: 3%;\r\n  top: 20%;\r\n}\r\n\r\n.clear-date-filter-button {\r\n  margin-left: 10px;\r\n  background-color: transparent;\r\n  border: none;\r\n  color: red;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n}\r\n\r\n.clear-all-filters {\r\n  cursor: pointer;\r\n  font-size: inherit;\r\n  margin-bottom: 10px;\r\n  padding: 0;\r\n  border-color: grey;\r\n  font-weight: bold;\r\n  padding: 5px;\r\n}\r\n\r\n.clear-all-filters:disabled:hover,\r\n.clear-all-filters:disabled:focus {\r\n  background-color: transparent !important;\r\n  border-color: gray !important;\r\n  color: gray !important;\r\n}\r\n\r\n.clear-all-filters:hover,\r\n.clear-all-filters:focus {\r\n  background-color: transparent;\r\n  border-color: gray;\r\n  color: gray;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  \r\n  .dashboard {\r\n    padding: 15px;\r\n    width: 85vw;\r\n  }\r\n\r\n  .feedback-item {\r\n    padding: 8px;\r\n  }\r\n\r\n  .cards-container {\r\n    flex-direction: column;\r\n    flex-wrap: nowrap; /* Ensure items don't wrap */\r\n  }\r\n\r\n  .dashboard-card {\r\n    margin: 10px 0;\r\n    flex: 1 1 100%; /* Full width for small screens */\r\n  }\r\n\r\n  .feedback-chart-row-1 {\r\n    flex-direction: column;\r\n    gap: 15px; /* Adjust gap for better fit on small screens */\r\n    flex-wrap: nowrap; /* Ensure items don't wrap */\r\n  }\r\n\r\n  .filters-container {\r\n    padding: 10px; /* Adjust padding for smaller screens */\r\n    background-color: white;\r\n    box-shadow: none;\r\n  }\r\n\r\n  .filters-container .row {\r\n    flex-direction: column; /* Stack columns vertically */\r\n  }\r\n\r\n  .filters-container .col {\r\n    width: 100%; /* Full width for each column */\r\n    margin-bottom: 10px; /* Space between stacked columns */\r\n  }\r\n\r\n  .filters-container .dashboard-date-filter {\r\n    width: 100%; /* Full width for date filter */\r\n    text-align: left; /* Align text to the left */\r\n  }\r\n\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .dashboard-card {\r\n    flex: 1 1 100%;\r\n  }\r\n\r\n  .chart-container {\r\n    flex: 1 1 100%;\r\n  }\r\n\r\n  .dashboard {\r\n    padding: 10px; /* Reduce padding for very small screens */\r\n  }\r\n\r\n  .feedback-item {\r\n    padding: 8px; /* Adjust padding for smaller screens */\r\n  }\r\n\r\n  .dashboard-card {\r\n    font-size: 12px; /* Smaller font size for very small screens */\r\n  }\r\n\r\n  .chart-heading {\r\n    font-size: 14px; /* Smaller font size for very small screens */\r\n  }\r\n\r\n  .dashboard-date-filter {\r\n    font-size: 12px; /* Adjust font size for small screens */\r\n    padding: 4px; /* Reduce padding for smaller screens */\r\n  }\r\n\r\n  .filters-container {\r\n    padding: 10px; /* Adjust padding for smaller screens */\r\n    background-color: white;\r\n    box-shadow: none;\r\n  }\r\n\r\n  .filters-container .row {\r\n    flex-direction: column; /* Stack columns vertically */\r\n  }\r\n\r\n  .filters-container .col {\r\n    width: 100%; /* Full width for each column */\r\n    margin-bottom: 10px; /* Space between stacked columns */\r\n  }\r\n\r\n  .filters-container .dashboard-date-filter {\r\n    width: 100%; /* Full width for date filter */\r\n    text-align: left; /* Align text to the left */\r\n  }\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
